import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {Table, message, Form, DatePicker, Select, Button, Checkbox} from 'antd';
import {offerApiServices} from "../../services/offer/OfferApiService";
import {ListCashbackAgentStates} from "./types/ListCashbackAgentTypes";
import withAuth from "../../hoc/withAuth";
import currencyFormat from "../../helper/currencyFormat";
import moment from "moment";
import {SearchOutlined} from "@ant-design/icons";

export interface ListCashbackAgentProps {
}

class ListCashbackAgent extends Component<ListCashbackAgentProps & any, ListCashbackAgentStates> {
    private readonly initState!: ListCashbackAgentStates;
    private tableColumnPaid: any = [
        {
            title: 'Offer Code',
            dataIndex: 'transaction_code',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value?.toString()?.toUpperCase()} <br/> <span className={`font-80-grey`}>{row?.area?.toUpperCase()}</span></span>
            })
        },
        {
            title: 'Status',
            dataIndex: 'cashback_status',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()}</span>
            })
        },
        {
            title: 'Type Cashback | Code',
            dataIndex: 'cashback_type',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{row?.agent_code?.toString()}</span><br/>
                    <span className={`font-80-grey`}>{(value) ? value?.toUpperCase() : "AGENT"}</span>
                </React.Fragment>
            })
        },
        {
            title: 'Time Range',
            dataIndex: 'cashback_time_range',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{row?.cashback_time?.substring(0, 10)}</span><br/>
                    <b className={`font-80-grey`}>{value?.toString()}</b>
                    <span style={{paddingLeft: 10}} className={`font-80-grey`}>{row?.cashback_responsibility?.toString()}</span>
                </React.Fragment>
            })
        },
        {
            title: 'Nilai Cashback',
            dataIndex: 'cashback_amount',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Minimum Payment',
            dataIndex: 'cashback_minimum_payment_terms',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Total Bayar (realtime)',
            dataIndex: 'amount_paid',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{currencyFormat(Number(value))}</span>
                    <i style={!row.is_paid_off ? {display: 'none'} : {fontSize: "80%", color: "#4F8D65FF", paddingLeft: 5}}>Lunas</i>
                </React.Fragment>
            })
        },
        {
            title: 'Catatan',
            dataIndex: 'notes',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
        {
            title: 'Kode Promo',
            dataIndex: 'promo_code',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
    ];

    private tableColumnNoPaid: any = [
        {
            title: 'Offer Code',
            dataIndex: 'transaction_code',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value?.toString()?.toUpperCase()} <br/> <span className={`font-80-grey`}>{row?.area?.toUpperCase()}</span></span>
            })
        },
        {
            title: 'Status',
            dataIndex: 'cashback_status',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()}</span>
            })
        },
        {
            title: 'Type Cashback | Code',
            dataIndex: 'cashback_type',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{row?.agent_code?.toString()}</span><br/>
                    <span className={`font-80-grey`}>{(value) ? value?.toUpperCase() : "AGENT"}</span>
                </React.Fragment>
            })
        },
        {
            title: 'Time Range',
            dataIndex: 'cashback_time_range',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{row?.cashback_time?.substring(0, 10)}</span><br/>
                    <b className={`font-80-grey`}>{value?.toString()}</b>
                    <span style={{paddingLeft: 10}} className={`font-80-grey`}>{row?.cashback_responsibility?.toString()}</span>
                </React.Fragment>
            })
        },
        {
            title: 'Nilai Cashback',
            dataIndex: 'cashback_amount',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Minimum Payment',
            dataIndex: 'cashback_minimum_payment_terms',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{currencyFormat(Number(value))}</span>
            })
        },
        {
            title: 'Catatan',
            dataIndex: 'notes',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
        {
            title: 'Kode Promo',
            dataIndex: 'promo_code',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value}</span>
            })
        },
    ];

    constructor(props: ListCashbackAgentProps & any | any) {
        super(props);

        this.initState = {
            processingFetchTableData: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataTable: [],
            pageSize: 50000,
            filterStartDate: moment().format('YYYY-MM-DD'),
            filterEndDate: moment().format('YYYY-MM-DD'),
            filterActive: "ALL",
            showPaidColumn: false,
            filterTimeRange: "ALL",
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: false,
            dealerCode: data.value,
        });

        await this.fetchData();
    }

    fetchData = async () => {
        // if(moment(this.state.filterStartDate).format("YYYY-MM-DD") !== moment(this.state.filterEndDate).format("YYYY-MM-DD")){
        //     Modal.error({
        //         title: 'Proses Gagal',
        //         content: 'pencarian hanya dapat dilakukan di 1 tanggal'
        //     });
        //     return;
        // }
        this.setState({
            processingFetchTableData: true,
            dataTable: [],
        });

        const activeFilter = (this.state.filterActive !== 'ALL') ? this.state.filterActive : "";
        let statusFilter = "";
        if (this.state.filterActive === "paid") {
            statusFilter = "paid";
        }
        if (this.state.filterActive === "reject") {
            statusFilter = "reject";
        }
        offerApiServices.getByDateDataCashbackAgent({
            startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            // endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
            endDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            active: activeFilter,
            status: statusFilter,
            showPaidColumn: this.state.showPaidColumn,
            filterTimeRange: this.state.filterTimeRange,
        }).then((dataFetch) => {
            this.setState({
                dataTable: dataFetch.data.data,
                processingFetchTableData: false,
            });
        }).catch(async (e) => {
            await this.promisedSetState({
                dataTable: [],
                processingFetchTableData: false,
            });
            message.error('Data Tidak Ditemukan');
        })
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    async componentDidMount() {

    }

    onFieldChange = <T extends keyof Pick<any, "filterActive" | "filterStartDate" | "filterEndDate" | "showPaidColumn" | "filterTimeRange">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "filterActive":
                currentState.filterActive = value;
                break;
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
            case "filterEndDate":
                currentState.filterEndDate = value;
                break;
            case "showPaidColumn":
                currentState.showPaidColumn = value;
                break;
            case "filterTimeRange":
                currentState.filterTimeRange = value;
                break;
        }
        currentState.dataTable = [];
        this.setState({
            ...currentState,
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Marketing`} breadcrumbMenu={`List Cashback Agent`} defaultSelectedKeys={['m-list-cashback-agent']} defaultOpenKeys={['sm-marketing']}>
                    <div style={{padding: 20}}>
                        <Form layout={`inline`}>
                            <Form.Item className={'padTop-10'} style={{width: 150}}>
                                <i className={`small-text-grey`}>Status</i>
                                <Select
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("filterActive", value)}
                                    value={this.state.filterActive}
                                >
                                    <Select.Option key={`ALL`} value={`ALL`}>{`Semua Data`}</Select.Option>
                                    <Select.Option key={`true`} value={`true`}>{`Active`}</Select.Option>
                                    <Select.Option key={`false`} value={`false`}>{`Not Active`}</Select.Option>
                                    <Select.Option key={`paid`} value={`paid`}>{`Paid`}</Select.Option>
                                    <Select.Option key={`reject`} value={`reject`}>{`Reject`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item className={'padTop-10'} style={{width: 150}}>
                                <i className={`small-text-grey`}>Time Range</i>
                                <Select
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("filterTimeRange", value)}
                                    value={this.state.filterTimeRange}
                                >
                                    <Select.Option key={`ALL`} value={`ALL`}>{`Semua Data`}</Select.Option>
                                    <Select.Option key={`true`} value={`next_week`}>{`next_week`}</Select.Option>
                                    <Select.Option key={`false`} value={`next_month`}>{`next_month`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item className={'padTop-10'} label="">
                                <i className={`small-text-grey`}>Tgl Cashback</i><br/>
                                <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterStartDate", event)} format={'YYYY-MM-DD'}/>
                            </Form.Item>
                            {/*<Form.Item className={'padTop-10'} label="">*/}
                            {/*    <i className={`small-text-grey`}>Tgl Akhir</i><br/>*/}
                            {/*    <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterEndDate", event)} format={'YYYY-MM-DD'}/>*/}
                            {/*</Form.Item>*/}

                            <Form.Item className={'padTop-20'}>
                                <Checkbox checked={this.state.showPaidColumn} onChange={e => this.onFieldChange("showPaidColumn", e.target.checked)}> <span className={`divider-stock-purchase`}> Tampilkan Pembayaran </span> </Checkbox>
                            </Form.Item>

                            <Form.Item className={'padTop-20'}>
                                <Button loading={this.state.processingFetchTableData} onClick={this.fetchData} type="primary" icon={<SearchOutlined/>}>Cari Data</Button>
                            </Form.Item>
                        </Form>
                    </div>

                    <Table
                        rowKey={'warehouse_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={(this.state?.showPaidColumn) ? this.tableColumnPaid : this.tableColumnNoPaid}
                        dataSource={this.state.dataTable}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ListCashbackAgent), 29));
